// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var ChevronRight = React.forwardRef(function ChevronRight(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ChevronRight" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 12L9.83894 19L8 17.2024L13.3221 12L8 6.79759L9.83894 5L17 12Z", fill: "currentColor" }))));
});
ChevronRight.displayName = 'ChevronRight';
export default ChevronRight;
//# sourceMappingURL=ChevronRight.js.map